const MS_DAY = 86400000;

export const toMid = (d: Date | number | string): Date => {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
};

export const addDays = (d: Date, n: number): Date =>
  toMid(new Date(toMid(d).getTime() + n * MS_DAY));

export const diffDays = (a: Date, b: Date): number =>
  Math.round((toMid(a).getTime() - toMid(b).getTime()) / MS_DAY);

export const iso = (d: Date): string => {
  const x = toMid(d);
  const m = `${x.getMonth() + 1}`.padStart(2, '0');
  const day = `${x.getDate()}`.padStart(2, '0');
  return `${x.getFullYear()}-${m}-${day}`;
};

export const fmtGrid = (d: Date): string => {
  const x = toMid(d);
  const day = `${x.getDate()}`.padStart(2, '0');
  const m = `${x.getMonth() + 1}`.padStart(2, '0');
  return `${day}-${m}-${x.getFullYear()}`;
};

export const parseISO = (s: string | undefined | null): Date => {
  if (!s) return toMid(new Date());   
  const [y, m, d] = s.split('-').map(Number);
  return toMid(new Date(y, m - 1, d));
};

export interface MonthSegment {
  label: string;
  days: number;
  offset: number; // day offset from chartStart where this month begins
}

export function buildMonthSegments(
  chartStart: Date,
  dayCount: number,
  locale = 'default',
): MonthSegment[] {
  const fmt = new Intl.DateTimeFormat(locale, { month: 'short', year: 'numeric' });
  const segments: MonthSegment[] = [];
  let key = '';
  for (let i = 0; i < dayCount; i++) {
    const d = addDays(chartStart, i);
    const k = `${d.getFullYear()}-${d.getMonth()}`;
    if (k !== key) {
      segments.push({ label: fmt.format(d), days: 0, offset: i });
      key = k;
    }
    segments[segments.length - 1].days += 1;
  }
  return segments;
}